export default __webpack_public_path__ + "e9db4005489e24809b62e61177c543a8.woff2";